const pageNameKey = "otaHistoryList";

export const otaHistoryListEn = {
  [pageNameKey]: {
    firmwareName: "Firmware Name",
    configurationName: "Configuration Name",
    version: "Version",
    digest: "Digest",
    size: "Size",
    uploader: "Uploader",
    uploadTime: "Upload Time",
    noRecords: "No records found",
  },
};

export const otaHistoryListPtBr = {
  [pageNameKey]: {
    firmwareName: "Nome do firmware",
    configurationName: "Nome da configuração",
    version: "Versão",
    digest: "Hash",
    size: "Tamanho",
    uploader: "Enviador",
    uploadTime: "Hora do upload",
    noRecords: "Nenhum registro encontrado",
  },
};

export const otaHistoryListDe = {
  [pageNameKey]: {
    firmwareName: "Firmware-Name",
    configurationName: "Konfigurationsname",
    version: "Version",
    digest: "Prüfsumme",
    size: "Größe",
    uploader: "Hochgeladen von",
    uploadTime: "Uploadzeit",
    noRecords: "Keine Einträge gefunden",
  },
};

export const otaHistoryListZhHans = {
  [pageNameKey]: {
    firmwareName: "固件名称",
    configurationName: "配置名称",
    version: "版本",
    digest: "摘要",
    size: "大小",
    uploader: "上传者",
    uploadTime: "上传时间",
    noRecords: "未找到记录",
  },
};

export const otaHistoryListIt = {
  [pageNameKey]: {
    firmwareName: "Nome del firmware",
    configurationName: "Nome della Configurazione",
    version: "Versione",
    digest: "Hash",
    size: "Dimensione",
    uploader: "Caricato da",
    uploadTime: "Tempo di caricamento",
    noRecords: "Nessun dato trovato",
  },
};

export const otaHistoryListEs = {
  [pageNameKey]: {
    firmwareName: "Nombre del firmware",
    configurationName: "Nombre de la configuración",
    version: "Versión",
    digest: "Hash",
    size: "Tamaño",
    uploader: "Subido por",
    uploadTime: "Hora de carga",
    noRecords: "No se encontraron registros",
  },
};

export const otaHistoryListNl = {
  [pageNameKey]: {
    configurationName: "Configuratienaam",
    digest: "Digest",
    firmwareName: "Firmwarenaam",
    noRecords: "Geen records gevonden",
    size: "Grootte",
    uploadTime: "Uploadtijd",
    uploader: "Uploader",
    version: "Versie",
  },
};

export const otaHistoryListTr = {
  [pageNameKey]: {
    configurationName: "Yapılandırma Adı",
    digest: "Özet",
    firmwareName: "Firmware Adı",
    noRecords: "Hiçbir kayıt bulunamadı",
    size: "Boyut",
    uploadTime: "Yükleme Zamanı",
    uploader: "Yükleyici",
    version: "Sürüm",
  },
};
